import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  ProductContainer, 
  ProductHeader, 
  ProductTitle, 
  ProductSubtitle, 
  ProductCard, 
  TechGrid, 
  DataStream,
  FormGroup,
  Label,
  Input,
  Button,
  ErrorMessage,
  SuccessMessage,
  LoadingSpinner,
  Logo,
  TechCircle,
  RangeSlider,
  RangeValue,
  NumberSelector,
  NumberButton,
  NumberDisplay,
  QuestionCard,
  RemoveButton,
  AIGenerationContainer,
  NeuralAnimation,
  NeuralConnection,
  GenerateButton,
  ProgressIndicator,
  ProgressStep,
  SectionTitle,
  ParticleContainer,
  Particle,
  ScanLine,
  HologramEffect,
  QuantumLoader,
  CodeFlowBackground,
  DigitalDistortionEffect,
} from './ProductStyles';
import DurationSelector from './components/DurationSelector';
import QualifyingQuestion from './components/QualifyingQuestion';
import QualifyingQuestionForm from './components/QualifyingQuestionForm';
import FAQItem from './components/FAQItem'; // Importar o novo componente FAQItem
import AvailabilitySelector from './components/AvailabilitySelector';
import authService from '../../services/authService';
import productService from '../../services/productService';

// Função para gerar um ID alfanumérico de comprimento específico
const generateAlphanumericId = (length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

// Ícones para o componente
const ProductIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 7L13 3L5 7L13 11L21 7ZM21 7V17L13 21M13 11V21M13 21L5 17V7" stroke="#64B6FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const TypeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6H20M4 12H20M4 18H20" stroke="#64B6FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const DurationIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="#64B6FF" strokeWidth="2"/>
    <path d="M12 6V12L16 14" stroke="#64B6FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CapacityIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 21V19C17 16.7909 15.2091 15 13 15H5C2.79086 15 1 16.7909 1 19V21M23 21V19C23 16.7909 21.2091 15 19 15H18M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7ZM19 7C19 8.10457 18.1046 9 17 9C15.8954 9 15 8.10457 15 7C15 5.89543 15.8954 5 17 5C18.1046 5 19 5.89543 19 7Z" stroke="#64B6FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const QuestionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.22766 9C8.77678 7.83481 10.2584 7 12.0001 7C14.2092 7 16.0001 8.34315 16.0001 10C16.0001 11.3994 14.7224 12.5751 12.9943 12.9066C12.4519 13.0106 12.0001 13.4477 12.0001 14M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#64B6FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const FAQIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 9H9.01M15 9H15.01M9 15H9.01M15 15H15.01M7 3H17C19.2091 3 21 4.79086 21 7V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V7C3 4.79086 4.79086 3 7 3Z" stroke="#64B6FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const AIIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#7B68EE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 5V19M5 12H19" stroke="#64B6FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Componente principal
const AddProduct = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showNeuralAnimation, setShowNeuralAnimation] = useState(false);
  const [generatingFAQs, setGeneratingFAQs] = useState(false);
  const [distortionActive, setDistortionActive] = useState(false);
  const [particles, setParticles] = useState([]);
  const productCardRef = useRef(null);
  const qualifyingFormRef = useRef(null);
  const typeInputRef = useRef(null);
  
  // Dados do formulário
  const [productName, setProductName] = useState('');
  const [appointmentType, setAppointmentType] = useState('');
  const [duration, setDuration] = useState(60);
  const [capacity, setCapacity] = useState(1);
  const [qualifyingQuestions, setQualifyingQuestions] = useState([]); // Garantindo que o estado inicial das perguntas qualificatórias seja um array vazio.
  const [faqs, setFaqs] = useState([]);
  const [availability, setAvailability] = useState('');
  
  // Efeito para verificar se o usuário está autenticado e tem as informações necessárias
  useEffect(() => {
    // Verificar se o usuário está autenticado e tem as informações necessárias
    const userData = authService.getUserData();
    
    // Se não houver dados do usuário ou se faltar informações essenciais, redirecionar para autenticação
    if (!userData || !userData.telefone) {
      console.log('Redirecionando para autenticação: usuário não autenticado ou sem telefone');
      navigate('/auth');
      return;
    }
    
    // Se o usuário não tiver segmento definido, redirecionar para a página de informações básicas
    if (!userData.segmento) {
      console.log('Redirecionando para registro: usuário sem segmento definido');
      navigate('/register');
      return;
    }
  }, [navigate]);
  
  // Efeito para criar partículas quando o mouse se move
  useEffect(() => {
    if (!productCardRef.current) return;
    
    const handleMouseMove = (e) => {
      const rect = productCardRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      if (Math.random() > 0.7) {
        const newParticle = {
          id: generateAlphanumericId(8),
          size: `${Math.random() * 4 + 2}px`,
          color: `rgba(${Math.random() * 100 + 50}, ${Math.random() * 100 + 100}, ${Math.random() * 100 + 155}, ${Math.random() * 0.5 + 0.3})`,
          top: `${y}px`,
          left: `${x}px`,
          x: `${(Math.random() - 0.5) * 200}px`,
          y: `${(Math.random() - 0.5) * 200}px`,
          r: `${Math.random() * 360}deg`,
          duration: `${Math.random() * 2 + 2}s`,
          delay: '0s'
        };
        
        setParticles(prev => [...prev.slice(-20), newParticle]);
      }
    };
    
    productCardRef.current.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      if (productCardRef.current) {
        productCardRef.current.removeEventListener('mousemove', handleMouseMove);
      }
    };
  }, []);
  
  // Limpar mensagens de erro quando o usuário começa a digitar
  useEffect(() => {
    setError('');
  }, [productName, appointmentType, duration, capacity]);
  
  // Efeito de distorção digital aleatório
  useEffect(() => {
    const distortionInterval = setInterval(() => {
      if (Math.random() > 0.7) {
        setDistortionActive(true);
        setTimeout(() => setDistortionActive(false), 500);
      }
    }, 5000);
    
    return () => clearInterval(distortionInterval);
  }, []);
  
  // Efeito para inicializar o componente
  useEffect(() => {
    // Efeito de distorção digital ao carregar o componente
    setDistortionActive(true);
    setTimeout(() => {
      setDistortionActive(false);
    }, 1500);
    
    // Limpar o estado das perguntas qualificatórias para garantir o formato correto
    setQualifyingQuestions([]);
  }, []);
  
  const handleAppointmentTypeChange = (e) => {
    setAppointmentType(e.target.value);
  };
  
  const handleAddQuestion = (newQuestionObj) => {
    // Verificar se a pergunta já existe para evitar duplicatas
    const questionExists = qualifyingQuestions.some(q => q.id === newQuestionObj.id);
    if (!questionExists) {
      setQualifyingQuestions(prev => [...prev, newQuestionObj]);
      
      // Efeito de partículas ao adicionar uma pergunta
      const formRect = document.getElementById('qualifying-question-form').getBoundingClientRect();
      const centerX = formRect.left + formRect.width / 2;
      const centerY = formRect.top + formRect.height / 2;
      
      for (let i = 0; i < 10; i++) {
        const newParticle = {
          id: generateAlphanumericId(8) + i,
          size: `${Math.random() * 4 + 2}px`,
          color: `rgba(${Math.random() * 100 + 50}, ${Math.random() * 100 + 100}, ${Math.random() * 100 + 155}, ${Math.random() * 0.5 + 0.5})`,
          top: `${centerY - productCardRef.current.getBoundingClientRect().top}px`,
          left: `${centerX - productCardRef.current.getBoundingClientRect().left}px`,
          x: `${(Math.random() - 0.5) * 300}px`,
          y: `${(Math.random() - 0.5) * 300}px`,
          r: `${Math.random() * 360}deg`,
          duration: `${Math.random() * 1 + 1}s`,
          delay: `${Math.random() * 0.2}s`
        };
        
        setParticles(prev => [...prev.slice(-30), newParticle]);
      }
    }
  };
  
  const handleRemoveQuestion = (id) => {
    setQualifyingQuestions(prev => prev.filter(q => q.id !== id));
  };

  const handleUpdateDisqualifyingAnswer = (questionId, answer) => {
    setQualifyingQuestions(prev => 
      prev.map(q => q.id === questionId ? { ...q, disqualifyingAnswer: answer } : q)
    );
  };
  
  // Utilizar o productService para gerar as FAQs
  const handleGenerateFAQs = () => {
    setGeneratingFAQs(true);
    setShowNeuralAnimation(true);
    setError('');
    
    const productData = {
      productName,
      appointmentType,
      duration,
      capacity
    };
    
    // Chamada à API da OpenAI para geração de FAQs
    (async () => {
      try {
        const generatedFAQs = await productService.generateFAQs(productData);
        setFaqs(generatedFAQs);
      } catch (error) {
        console.error('Erro ao gerar FAQs:', error);
        setError('Não foi possível gerar as perguntas frequentes. Verifique sua conexão com a internet e tente novamente.');
        setFaqs([]);
      } finally {
        setShowNeuralAnimation(false);
        setGeneratingFAQs(false);
      }
    })();
  };
  
  // Função para adicionar uma nova FAQ manualmente
  const handleAddNewFAQ = () => {
    const newFAQ = {
      id: generateAlphanumericId(10),
      question: "",
      answer: ""
    };
    setFaqs(prev => [...prev, newFAQ]);
  };
  
  // Função para atualizar a resposta de uma FAQ de forma otimizada
  const handleFAQAnswerChange = useCallback((faqId, answer, question) => {
    setFaqs(prevFaqs => {
      const updatedFaqs = [...prevFaqs];
      const index = updatedFaqs.findIndex(item => item.id === faqId);
      if (index !== -1) {
        // Se o campo de pergunta foi atualizado
        if (question !== undefined) {
          updatedFaqs[index] = { ...updatedFaqs[index], question };
        }
        // Se o campo de resposta foi atualizado
        if (answer !== undefined) {
          updatedFaqs[index] = { ...updatedFaqs[index], answer };
        }
      }
      return updatedFaqs;
    });
  }, []);

  const handleSubmit = async () => {
    // Validação dos campos
    if (!productName.trim()) {
      setError('Por favor, informe o nome do produto.');
      return;
    }
    
    if (!appointmentType.trim()) {
      setError('Por favor, informe o tipo de agendamento.');
      return;
    }
    
    // Validar a capacidade de agendamentos simultâneos
    if (capacity < 1) {
      setError('A quantidade de agendamentos simultâneos deve ser pelo menos 1.');
      return;
    }
    
    // Validar a disponibilidade
    if (!availability || availability.trim() === '') {
      setError('Por favor, configure a disponibilidade de horários.');
      return;
    }
    
    // Validar que pelo menos uma FAQ tenha resposta
    if (faqs.length === 0) {
      setError('Por favor, gere as perguntas frequentes antes de continuar.');
      return;
    }
    
    const hasAnsweredFAQ = faqs.some(faq => faq.answer && faq.answer.trim() !== '');
    if (!hasAnsweredFAQ) {
      setError('Por favor, responda pelo menos uma pergunta frequente antes de continuar.');
      return;
    }
    
    setIsLoading(true);
    setError('');
    
    try {
      // Obter as perguntas qualificatórias do formulário
      let finalQualifyingQuestions = qualifyingQuestions;
      
      // Se temos uma referência para o formulário de perguntas, obter as perguntas válidas dele
      if (qualifyingFormRef.current && qualifyingFormRef.current.getValidQuestions) {
        const formQuestions = qualifyingFormRef.current.getValidQuestions();
        // Mesclar as perguntas do formulário com as que já estão no estado
        // (evitando duplicatas por ID)
        const existingIds = qualifyingQuestions.map(q => q.id);
        const newQuestions = formQuestions.filter(q => !existingIds.includes(q.id));
        finalQualifyingQuestions = [...qualifyingQuestions, ...newQuestions];
      }
      
      // Log para debug - remover em produção
      console.log('Disponibilidade formatada:', availability);
      
      const productData = {
        id: generateAlphanumericId(16), // ID único alfanumérico de 16 caracteres
        productName,
        appointmentType,
        duration,
        capacity,
        qualifyingQuestions: finalQualifyingQuestions,
        faqs,
        availability, // Adiciona a disponibilidade formatada
        createdAt: new Date().toISOString()
      };
      
      // Salvar o produto usando o productService
      const response = await productService.saveProduct(productData);
      
      if (response === 'sucesso') {
        setSuccess('Produto adicionado com sucesso!');
        
        // Redirecionar para a página de onboarding após um breve delay
        setTimeout(() => {
          window.scrollTo(0, 0); // Rola a página para o topo
          navigate('/onboarding');
        }, 2000);
      } else {
        setError('Ocorreu um erro ao adicionar o produto. Tente novamente mais tarde.');
      }
    } catch (err) {
      console.error('Erro ao adicionar produto:', err);
      setError('Ocorreu um erro ao processar sua solicitação. Tente novamente mais tarde.');
    } finally {
      setIsLoading(false);
    }
  };
  
  // Renderizar conexões neurais para a animação de IA
  const renderNeuralConnections = () => {
    const connections = [];
    for (let i = 0; i < 15; i++) {
      connections.push(
        <NeuralConnection
          key={i}
          top={`${Math.random() * 100}%`}
          left={`${Math.random() * 100}%`}
          width={`${Math.random() * 100 + 50}px`}
          rotate={`${Math.random() * 360}deg`}
          delay={`${Math.random() * 2}s`}
        />
      );
    }
    return connections;
  };
  
  return (
    <ProductContainer>
      <ProductHeader>
        <Logo src="/favicon.png" alt="BIANCA Logo" />
        <ProductTitle>BIANCA</ProductTitle>
        <ProductSubtitle>Adicionar Produto</ProductSubtitle>
      </ProductHeader>
      
      <ProductCard ref={productCardRef}>
        <TechGrid />
        <DataStream />
        <CodeFlowBackground />
        <DigitalDistortionEffect active={distortionActive} />
        <TechCircle size="200%" color="rgba(64, 128, 255, 0.2)" delay={0} />
        <TechCircle size="150%" color="rgba(64, 128, 255, 0.3)" delay={1} />
        <TechCircle size="120%" color="rgba(64, 128, 255, 0.1)" delay={2} />
        <HologramEffect />
        <ScanLine delay={0} />
        <ScanLine delay={3} />
        
        <ParticleContainer>
          {particles.map(particle => (
            <Particle
              key={particle.id}
              size={particle.size}
              color={particle.color}
              top={particle.top}
              left={particle.left}
              x={particle.x}
              y={particle.y}
              r={particle.r}
              duration={particle.duration}
              delay={particle.delay}
            />
          ))}
        </ParticleContainer>
        
        <SectionTitle>Informações Básicas</SectionTitle>
        
        <FormGroup delay="0.1">
          <Label htmlFor="productName">
            <ProductIcon /> Nome do Produto
          </Label>
          <Input
            id="productName"
            type="text"
            placeholder="Digite o nome do seu produto"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            disabled={isLoading}
          />
        </FormGroup>
        
        <FormGroup delay="0.2">
          <Label htmlFor="appointmentType">
            <TypeIcon /> Tipo de Agendamento
          </Label>
          <div style={{ position: 'relative' }}>
            <Input
              id="appointmentType"
              type="text"
              placeholder="Ex: Consulta, Reunião, Demonstração..."
              value={appointmentType}
              onChange={handleAppointmentTypeChange}
              disabled={isLoading}
              ref={typeInputRef}
            />
          </div>
        </FormGroup>
        
        <FormGroup delay="0.3">
          <DurationSelector 
            value={duration}
            onChange={(value) => setDuration(value)}
            disabled={isLoading}
          />
        </FormGroup>
        
        <FormGroup delay="0.4">
          <Label htmlFor="capacity">
            <CapacityIcon /> Capacidade de Atendimentos Simultâneos
          </Label>
          <NumberSelector>
            <NumberButton
              type="button"
              onClick={() => setCapacity(prev => Math.max(1, prev - 1))}
              disabled={capacity <= 1 || isLoading}
            >
              -
            </NumberButton>
            <NumberDisplay>{capacity}</NumberDisplay>
            <NumberButton
              type="button"
              onClick={() => setCapacity(prev => prev + 1)}
              disabled={isLoading}
            >
              +
            </NumberButton>
          </NumberSelector>
        </FormGroup>
        
        <SectionTitle>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "3px" }}>
            <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5ZM21 8.5V17M16 11H8M8 17V11M8 11H16" stroke="#64B6FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 13.5C11.45 13.5 11 13.95 11 14.5C11 15.05 11.45 15.5 12 15.5C12.55 15.5 13 15.05 13 14.5C13 13.95 12.55 13.5 12 13.5Z" stroke="#64B6FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 13.5C15.45 13.5 15 13.95 15 14.5C15 15.05 15.45 15.5 16 15.5C16.55 15.5 17 15.05 17 14.5C17 13.95 16.55 13.5 16 13.5Z" stroke="#64B6FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 13.5C7.45 13.5 7 13.95 7 14.5C7 15.05 7.45 15.5 8 15.5C8.55 15.5 9 15.05 9 14.5C9 13.95 8.55 13.5 8 13.5Z" stroke="#64B6FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 17.5C11.45 17.5 11 17.95 11 18.5C11 19.05 11.45 19.5 12 19.5C12.55 19.5 13 19.05 13 18.5C13 17.95 12.55 17.5 12 17.5Z" stroke="#64B6FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 17.5C15.45 17.5 15 17.95 15 18.5C15 19.05 15.45 19.5 16 19.5C16.55 19.5 17 19.05 17 18.5C17 17.95 16.55 17.5 16 17.5Z" stroke="#64B6FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 17.5C7.45 17.5 7 17.95 7 18.5C7 19.05 7.45 19.5 8 19.5C8.55 19.5 9 19.05 9 18.5C9 17.95 8.55 17.5 8 17.5Z" stroke="#64B6FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Disponibilidade</span>
        </SectionTitle>
        
        <AvailabilitySelector 
          duration={duration} 
          onChange={(formattedAvailability) => {
            console.log('Disponibilidade atualizada:', formattedAvailability);
            setAvailability(formattedAvailability);
          }}
        />
        
        <SectionTitle>
          <QuestionIcon /> Perguntas Qualificatórias
        </SectionTitle>
        
        {/* Novo formulário interativo para adicionar perguntas */}
        <div id="qualifying-question-form">
          <QualifyingQuestionForm 
            ref={qualifyingFormRef}
            onAddQuestion={handleAddQuestion} 
            existingQuestions={qualifyingQuestions}
          />
        </div>
        
        {/* Lista de perguntas qualificatórias */}
        {qualifyingQuestions.length > 0 ? (
          qualifyingQuestions.map(question => (
            <QualifyingQuestion 
              key={question.id} 
              question={question} 
              onRemove={handleRemoveQuestion}
              onUpdateDisqualifyingAnswer={handleUpdateDisqualifyingAnswer}
            />
          ))
        ) : (
          <div style={{ 
            padding: '1rem', 
            textAlign: 'center', 
            color: 'rgba(255, 255, 255, 0.6)',
            fontStyle: 'italic',
            background: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
            marginBottom: '1rem',
            display: 'none' 
          }}>
            Adicione perguntas qualificatórias para seu produto
          </div>
        )}
        
        <SectionTitle>
          <FAQIcon /> Perguntas Frequentes
        </SectionTitle>
        
        <AIGenerationContainer>
          {generatingFAQs ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '2rem 0',
              position: 'relative',
              height: '180px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.2)',
              borderRadius: '8px',
              overflow: 'hidden',
              border: '1px solid rgba(100, 182, 255, 0.1)'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '1px',
                background: 'linear-gradient(to right, transparent, rgba(100, 182, 255, 0.5), transparent)',
                animation: 'scan 2s ease-in-out infinite',
                zIndex: 1
              }}></div>
              
              <div style={{
                width: '40px',
                height: '40px',
                border: '1px solid rgba(100, 182, 255, 0.3)',
                borderRadius: '50%',
                position: 'relative',
                marginBottom: '20px'
              }}>
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  width: '20px',
                  height: '20px',
                  backgroundColor: 'rgba(100, 182, 255, 0.8)',
                  borderRadius: '50%',
                  transform: 'translate(-50%, -50%) scale(0.8)',
                  animation: 'pulse 1.5s ease-in-out infinite'
                }}></div>
              </div>
              
              <p style={{ 
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '0.9rem',
                letterSpacing: '1px',
                position: 'relative',
                zIndex: 2
              }}>
                Gerando perguntas
              </p>
              
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '8px'
              }}>
                <span style={{
                  width: '4px',
                  height: '4px',
                  backgroundColor: 'rgba(100, 182, 255, 0.7)',
                  borderRadius: '50%',
                  margin: '0 2px',
                  animation: 'blink 1.4s infinite 0.2s'
                }}></span>
                <span style={{
                  width: '4px',
                  height: '4px',
                  backgroundColor: 'rgba(100, 182, 255, 0.7)',
                  borderRadius: '50%',
                  margin: '0 2px',
                  animation: 'blink 1.4s infinite 0.4s'
                }}></span>
                <span style={{
                  width: '4px',
                  height: '4px',
                  backgroundColor: 'rgba(100, 182, 255, 0.7)',
                  borderRadius: '50%',
                  margin: '0 2px',
                  animation: 'blink 1.4s infinite 0.6s'
                }}></span>
              </div>
              
              <style jsx>{`
                @keyframes scan {
                  0% { transform: translateY(0); opacity: 0; }
                  50% { opacity: 1; }
                  100% { transform: translateY(180px); opacity: 0; }
                }
                
                @keyframes pulse {
                  0% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.5; }
                  50% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
                  100% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.5; }
                }
                
                @keyframes blink {
                  0% { opacity: 0.2; }
                  20% { opacity: 1; }
                  100% { opacity: 0.2; }
                }
                
                @keyframes scanline {
                  0% { transform: translateX(0); opacity: 0; }
                  50% { opacity: 1; }
                  100% { transform: translateX(100%); opacity: 0; }
                }
              `}</style>
            </div>
          ) : faqs.length > 0 ? (
            <div style={{ 
              maxHeight: '400px', 
              overflowY: 'auto', 
              padding: '0.5rem',
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
              boxShadow: 'inset 0 0 10px rgba(0, 0, 0, 0.2)'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.5rem 1rem',
                marginBottom: '1rem',
                borderBottom: '1px solid rgba(100, 182, 255, 0.3)'
              }}>
                <h3 style={{ color: '#64B6FF', margin: 0 }}>Perguntas Frequentes</h3>
                <span style={{ 
                  backgroundColor: 'rgba(100, 182, 255, 0.2)', 
                  color: '#64B6FF',
                  padding: '0.25rem 0.75rem',
                  borderRadius: '12px',
                  fontSize: '0.8rem',
                  fontWeight: 'bold'
                }}>
                  {faqs.length} perguntas geradas
                </span>
              </div>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: '1fr', 
                gap: '1rem',
                paddingRight: '0.5rem'
              }}>
                {faqs.map(faq => (
                  <FAQItem 
                    key={faq.id} 
                    faq={faq} 
                    onAnswerChange={handleFAQAnswerChange} 
                  />
                ))}
              </div>
              <button
                type="button"
                onClick={handleAddNewFAQ}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  background: 'rgba(20, 30, 60, 0.4)',
                  border: '1px solid rgba(64, 128, 255, 0.15)',
                  borderRadius: '6px',
                  color: 'rgba(255, 255, 255, 0.7)',
                  padding: '0.6rem',
                  width: '100%',
                  cursor: 'pointer',
                  transition: 'all 0.25s ease',
                  fontWeight: '400',
                  fontSize: '0.85rem',
                  marginTop: '1rem',
                  position: 'relative',
                  overflow: 'hidden',
                  backdropFilter: 'blur(2px)',
                  letterSpacing: '0.5px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(30, 40, 80, 0.5)';
                  e.currentTarget.style.borderColor = 'rgba(64, 128, 255, 0.3)';
                  e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 0 10px rgba(64, 128, 255, 0.3)';
                  // Rotate the icon
                  const svg = e.currentTarget.querySelector('svg');
                  if (svg) {
                    svg.style.opacity = '1';
                    svg.style.transform = 'rotate(90deg)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(20, 30, 60, 0.4)';
                  e.currentTarget.style.borderColor = 'rgba(64, 128, 255, 0.15)';
                  e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  // Reset icon rotation
                  const svg = e.currentTarget.querySelector('svg');
                  if (svg) {
                    svg.style.opacity = '0.8';
                    svg.style.transform = 'rotate(0deg)';
                  }
                }}
              >
                {/* Shimmer effect */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: '-100px',
                  width: '100px',
                  height: '100%',
                  background: 'linear-gradient(90deg, transparent, rgba(64, 128, 255, 0.1), transparent)',
                  animation: 'buttonShimmer 3s infinite',
                  animationDelay: '1s'
                }}></div>
                
                <style jsx>{`
                  @keyframes buttonShimmer {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(400px); }
                  }
                  @keyframes pulseGlow {
                    0% { box-shadow: 0 0 0 rgba(64, 128, 255, 0); }
                    50% { box-shadow: 0 0 10px rgba(64, 128, 255, 0.3); }
                    100% { box-shadow: 0 0 0 rgba(64, 128, 255, 0); }
                  }
                `}</style>
                
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
                  opacity: '0.8',
                  transition: 'all 0.25s ease'
                }}>
                  <path d="M12 5V19M5 12H19" stroke="#64B6FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Nova Pergunta
              </button>
            </div>
          ) : (
            <GenerateButton
              type="button"
              onClick={handleGenerateFAQs}
              disabled={isLoading || generatingFAQs || !productName || !appointmentType}
              style={{
                background: 'rgba(0, 0, 0, 0.3)',
                border: '1px solid rgba(100, 182, 255, 0.5)',
                borderRadius: '4px',
                color: 'rgba(255, 255, 255, 0.9)',
                padding: '8px 16px',
                fontSize: '0.9rem',
                fontWeight: '500',
                letterSpacing: '0.5px',
                transition: 'all 0.2s ease',
                backdropFilter: 'blur(5px)',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(100, 182, 255, 0.2)',
                position: 'relative',
                overflow: 'hidden',
                cursor: (!productName || !appointmentType) ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                width: '100%'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(100, 182, 255, 0.3), 0 0 0 1px rgba(100, 182, 255, 0.3)';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(100, 182, 255, 0.2)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              {generatingFAQs ? (
                <>
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '3px',
                    height: '100%',
                    background: 'linear-gradient(to bottom, transparent, #64B6FF, transparent)',
                    animation: 'scanline 1.5s ease-in-out infinite',
                    zIndex: 1
                  }}></div>
                  <LoadingSpinner /> Processando
                </>
              ) : (
                <>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16 11H13V8C13 7.45 12.55 7 12 7C11.45 7 11 7.45 11 8V11H8C7.45 11 7 11.45 7 12C7 12.55 7.45 13 8 13H11V16C11 16.55 11.45 17 12 17C12.55 17 13 16.55 13 16V13H16C16.55 13 17 12.55 17 12C17 11.45 16.55 11 16 11Z" fill="#64B6FF"/>
                  </svg>
                  Clique para Gerar as Perguntas
                </>
              )}
            </GenerateButton>
          )}
        </AIGenerationContainer>
        
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {success && <SuccessMessage>{success}</SuccessMessage>}
        
        <Button
          onClick={handleSubmit}
          disabled={isLoading}
          style={{ marginTop: '2rem' }}
        >
          {isLoading ? (
            <>
              <LoadingSpinner /> Enviando...
            </>
          ) : (
            <>Concluir Cadastro</>
          )}
        </Button>
      </ProductCard>
    </ProductContainer>
  );
};

export default AddProduct;
